import {
  EarningsInsightPreviewResponse,
  earningsInsights,
} from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const QUERY_KEY_EARNINGS_INSIGHT_PREVIEW = 'QUERY_KEY_EARNINGS_INSIGHT_PREVIEW';

export const useGetEarningsInsightPreview = (earningsInsightId: string) =>
  useQuery({
    queryKey: [QUERY_KEY_EARNINGS_INSIGHT_PREVIEW, earningsInsightId],
    queryFn: ({ signal }) => {
      const { path, schema } = earningsInsights.getEarningsInsightPreview;
      return wretchRequest<EarningsInsightPreviewResponse>(
        path(earningsInsightId),
        {
          method: 'get',
          schema,
          signal,
        }
      );
    },
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !!earningsInsightId,
  });
